var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconReplay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39 39",
    style: {
      enableBackground: "new 0 0 39 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3130",
    transform: "translate(-370.757 -370.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-refresh",
    d: "M385.1,403.7c0.4-0.4,1.1-0.5,1.6-0.1c5.3,4.5,13.4,3.9,17.9-1.4c4.5-5.3,3.9-13.4-1.4-17.9 c-5-4.2-12.3-4-17,0.5c-0.1,0.1-0.2,0.3,0,0.4l0,0l2.8,2.8c0.5,0.5,0.5,1.3,0,1.8c-0.2,0.2-0.4,0.3-0.6,0.3l-9,1.6 c-0.7,0.2-1.3-0.3-1.5-0.9c-0.1-0.2-0.1-0.4,0-0.6l1.7-9c0.2-0.7,0.8-1.1,1.5-0.9c0.2,0.1,0.5,0.2,0.6,0.3l2.5,2.5 c0.1,0.1,0.3,0.1,0.4,0l0,0c6-5.7,15.5-5.4,21.2,0.6c5.7,6,5.4,15.5-0.6,21.2c-5.5,5.3-14.1,5.5-20,0.6c-0.5-0.4-0.6-1.1-0.2-1.7 C385,403.8,385,403.7,385.1,403.7L385.1,403.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-play",
    d: "M393.1,390.2v8.9c0,0.1,0.1,0.3,0.2,0.3c0.1,0,0.1,0,0.1-0.1l7.1-4.5c0.1-0.1,0.2-0.3,0.1-0.4 c0-0.1-0.1-0.1-0.1-0.1l-7.1-4.5c-0.1-0.1-0.3,0-0.3,0.1C393.1,390.1,393,390.1,393.1,390.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReplay);
export default __webpack_public_path__ + "static/media/icon-replay.f5e9e64b8c62bcf3772a41f067002fa3.svg";
export { ForwardRef as ReactComponent };